import React, { useState } from 'react';
import Button from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';

export default function RequestService() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate API call
    setTimeout(() => setIsSubmitted(true), 500);
  };

  if (isSubmitted) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4">
        <div className="text-center max-w-md bg-white p-8 rounded-2xl shadow-lg border border-slate-100">
          <div className="w-20 h-20 bg-green-100 text-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <SafeIcon name="Check" className="text-4xl" />
          </div>
          <h2 className="text-2xl font-bold mb-4">Request Received!</h2>
          <p className="text-slate-600 mb-8">Thank you. Our dispatch team will review your request and call you back shortly to confirm your appointment time.</p>
          <Button onClick={() => setIsSubmitted(false)} variant="primary">Book Another Service</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <div className="text-center mb-12">
        <h1 className="text-3xl md:text-5xl font-bold mb-4">Book a Plumber</h1>
        <p className="text-lg text-slate-600">Fill out the form below. For immediate emergencies, please call us instead.</p>
      </div>

      <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-200">
        <div className="bg-slate-50 p-6 border-b border-slate-200 flex items-start gap-4">
          <SafeIcon name="Info" className="text-secondary text-2xl shrink-0 mt-1" />
          <p className="text-sm text-slate-600">Standard service calls carry a dispatch fee which is waived if you proceed with the repair. Upfront pricing will be provided before any work begins.</p>
        </div>
        
        <form onSubmit={handleSubmit} className="p-8 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">First Name *</label>
              <input required type="text" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Last Name *</label>
              <input required type="text" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Phone Number *</label>
              <input required type="tel" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Email Address</label>
              <input type="email" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none" />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Service Address (Montreal & Surrounding) *</label>
            <input required type="text" placeholder="123 Main St, Appt 4" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none" />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">What do you need help with? *</label>
            <select required className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none bg-white">
              <option value="">Select a service...</option>
              <option value="drain">Clogged Drain / Toilet</option>
              <option value="leak">Water Leak</option>
              <option value="heater">Water Heater Issue</option>
              <option value="install">New Installation</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Describe the problem in detail</label>
            <textarea rows="4" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none" placeholder="e.g. Toilet is constantly running and leaking from the base..."></textarea>
          </div>

          <div className="flex items-center gap-3 bg-red-50 p-4 rounded-lg border border-red-100">
            <input type="checkbox" id="emergency" className="w-5 h-5 text-red-600 rounded focus:ring-red-500" />
            <label htmlFor="emergency" className="text-red-800 font-medium cursor-pointer">This is an emergency (requires rapid response)</label>
          </div>

          <Button type="submit" variant="primary" className="w-full py-4 text-lg">
            Submit Service Request
          </Button>
        </form>
      </div>
    </div>
  );
}